var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1),_vm._v(" "),_c('notifications',{attrs:{"group":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }